import React from "react";
import { Row, Col, Tabs } from "antd";
import { BellOutlined, MailOutlined, UnorderedListOutlined } from "@ant-design/icons";
import NotificationsHeader from "./notifications-header";
import TemplateLibrary from "./template-library";
import TemplatePreview from "./template-preview";
import NotificationRules from "./notification-rules";
import CommunicationHistory from "./communication-history";
import { ModalTemplate } from "../modal-notifications";
import { UserNotificationsTab } from "./user-notifications-tab";
import { SystemLogsTab } from "./system-logs-tab";

export const Notifications: React.FC = () => {
  const tabItems = [
    {
      key: "user-notifications",
      label: (
        <span>
          <BellOutlined />
          User Notifications
        </span>
      ),
      children: <UserNotificationsTab />,
    },
    {
      key: "system-logs",
      label: (
        <span>
          <UnorderedListOutlined />
          System Logs
        </span>
      ),
      children: <SystemLogsTab />,
    },
    {
      key: "templates-rules",
      label: (
        <span>
          <MailOutlined />
          Email/SMS Messaging
        </span>
      ),
      children: (
        <>
          <NotificationsHeader />
          <TemplateLibrary />
          <Row gutter={24} style={{ marginBottom: 24 }}>
            <Col span={12}>
              <TemplatePreview />
            </Col>
            <Col span={12}>
              <NotificationRules />
            </Col>
          </Row>
          <CommunicationHistory />
          <ModalTemplate />
        </>
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Tabs defaultActiveKey="user-notifications" type="card" items={tabItems} />
    </div>
  );
};
